import * as React from 'react';

import { cn } from '../../../lib/stylingUtils';

export type TabProps = {
  selected?: boolean;
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'neutral';
  onClick?: () => void;
};

export const Tab = ({ variant = 'neutral', ...props }: TabProps) => (
  <div
    className={cn(
      '@Tab cursor-pointer border-b-[3px] border-transparent py-4 text-sm font-medium transition-colors',
      'text-neutral/60 hover:border-neutral/20 hover:text-neutral/80',
      props.selected && 'border-neutral! text-neutral',
      variant === 'primary' && props.selected && 'border-primary! text-primary',
      props.className,
    )}
    onClick={props.onClick}
  >
    {props.children}
  </div>
);

export type TabBarProps = {
  tabs: {
    key: string;
    label: React.ReactNode | ((selected: boolean) => React.ReactNode);
    onClick?: () => void;
  }[];
  onChange: (key: string) => void;
  selectedKey: string;
};

export const TabBar = ({ tabs, selectedKey, onChange }: TabBarProps) => {
  const handleClick = (key: string) => () => {
    onChange(key);
    tabs.find((tab) => tab.key === key)?.onClick?.();
  };

  return (
    <div className="@TabBar border-b border-neutral/20 bg-white px-4">
      <div className="flex space-x-3">
        {tabs.map((tab) => (
          <Tab
            key={tab.key}
            selected={selectedKey === tab.key}
            onClick={handleClick(tab.key)}
          >
            {typeof tab.label === 'function'
              ? tab.label(selectedKey === tab.key)
              : tab.label}
          </Tab>
        ))}
      </div>
    </div>
  );
};
